import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-kt-drawer-width"]
const _hoisted_2 = {
  key: 0,
  class: "aside-primary d-flex flex-column align-items-center flex-row-auto"
}
const _hoisted_3 = { class: "aside-logo d-flex flex-column align-items-center flex-column-auto py-4 pt-lg-10 pb-lg-7" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Logo",
  src: "media/logos/logo-compact.svg",
  class: "mh-50px"
}, null, -1)
const _hoisted_5 = {
  class: "aside-nav d-flex flex-column align-items-center flex-column-fluid pt-0 pb-5",
  id: "kt_aside_nav"
}
const _hoisted_6 = {
  class: "hover-scroll-y",
  "data-kt-scroll": "true",
  "data-kt-scroll-height": "auto",
  "data-kt-scroll-dependencies": "#kt_aside_logo, #kt_aside_footer",
  "data-kt-scroll-wrappers": "#kt_aside_nav",
  "data-kt-scroll-offset": "10px"
}
const _hoisted_7 = {
  class: "nav flex-column",
  role: "tablist"
}
const _hoisted_8 = {
  class: "nav-item mb-1",
  title: "Features"
}
const _hoisted_9 = {
  href: "#",
  class: "nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white active",
  "data-bs-toggle": "tab",
  "data-bs-target": "#kt_aside_tab_1",
  role: "tab"
}
const _hoisted_10 = { class: "svg-icon svg-icon-2 svg-icon-lg-1" }
const _hoisted_11 = {
  class: "nav-item mb-1",
  title: "Members"
}
const _hoisted_12 = {
  href: "#",
  class: "nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white",
  "data-bs-toggle": "tab",
  "data-bs-target": "#kt_aside_tab_2",
  role: "tab"
}
const _hoisted_13 = { class: "svg-icon svg-icon-2 svg-icon-lg-1" }
const _hoisted_14 = {
  class: "nav-item mb-1",
  title: "Latest Reports"
}
const _hoisted_15 = {
  href: "#",
  class: "nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white",
  "data-bs-toggle": "tab",
  "data-bs-target": "#kt_aside_tab_3",
  role: "tab"
}
const _hoisted_16 = { class: "svg-icon svg-icon-2 svg-icon-lg-1" }
const _hoisted_17 = {
  class: "nav-item mb-1",
  title: "Project Management"
}
const _hoisted_18 = {
  href: "#",
  class: "nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white",
  "data-bs-toggle": "tab",
  "data-bs-target": "#kt_aside_tab_2",
  role: "tab"
}
const _hoisted_19 = { class: "svg-icon svg-icon-2 svg-icon-lg-1" }
const _hoisted_20 = {
  class: "nav-item mb-1",
  title: "User Management"
}
const _hoisted_21 = {
  href: "#",
  class: "nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white",
  "data-bs-toggle": "tab",
  "data-bs-target": "#kt_aside_tab_3",
  role: "tab"
}
const _hoisted_22 = { class: "svg-icon svg-icon-2 svg-icon-lg-1" }
const _hoisted_23 = {
  class: "nav-item mb-1",
  title: "Finance & Accounting"
}
const _hoisted_24 = {
  href: "#",
  class: "nav-link h-40px w-40px h-lg-50px w-lg-50px btn btn-custom btn-icon btn-color-white",
  "data-bs-toggle": "tab",
  "data-bs-target": "#kt_aside_tab_6",
  role: "tab"
}
const _hoisted_25 = { class: "svg-icon svg-icon-2 svg-icon-lg-1" }
const _hoisted_26 = {
  class: "aside-footer d-flex flex-column align-items-center flex-column-auto py-5 py-lg-7",
  id: "kt_aside_footer"
}
const _hoisted_27 = {
  key: 0,
  class: "btn btn-sm btn-icon btn-white btn-active-primary position-absolute translate-middle start-100 end-0 bottom-0 shadow-sm d-none d-lg-flex",
  id: "kt_aside_toggle",
  "data-kt-toggle": "true",
  "data-kt-toggle-state": "active",
  "data-kt-toggle-target": "body",
  "data-kt-toggle-name": "aside-minimize",
  title: "Toggle Aside"
}
const _hoisted_28 = { class: "svg-icon svg-icon-2 rotate-180" }
const _hoisted_29 = { class: "mb-2" }
const _hoisted_30 = {
  type: "button",
  class: "btn btn-custom h-40px w-40px h-lg-50px w-lg-50px btn-icon btn-color-white",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-overflow": "true",
  "data-kt-menu-placement": "top-start",
  "data-kt-menu-flip": "top-end"
}
const _hoisted_31 = { class: "svg-icon svg-icon-2 svg-icon-lg-1" }
const _hoisted_32 = {
  key: 1,
  class: "aside-secondary d-flex flex-row-fluid bg-white"
}
const _hoisted_33 = {
  class: "aside-logo py-2 pb-7 w-100",
  id: "kt_aside_logo"
}
const _hoisted_34 = ["src"]
const _hoisted_35 = ["src"]
const _hoisted_36 = {
  key: 1,
  class: "tab-content"
}
const _hoisted_37 = {
  class: "tab-pane fade show active",
  id: "kt_aside_tab_1"
}
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "kt_aside_tab_2"
}, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. ", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", {
  class: "tab-pane fade",
  id: "kt_aside_tab_3"
}, " Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_Dropdown3 = _resolveComponent("Dropdown3")!
  const _component_KTAsideMenu = _resolveComponent("KTAsideMenu")!

  return (_ctx.displayAsidePrimary || _ctx.displayAsideSecondary)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        id: "kt_aside",
        ref: "ktAsideRef",
        class: _normalizeClass(["aside aside-width", {
      'aside-width_full': _ctx.sidebarStateExpand
    }]),
        "data-kt-drawer": "true",
        "data-kt-drawer-name": "aside",
        "data-kt-drawer-activate": "{default: true, lg: false}",
        "data-kt-drawer-overlay": "true",
        "data-kt-drawer-width": 
      _ctx.displayAsideSecondary ? `{default:'200px', '300px': '250px'}` : `70px`
    ,
        "data-kt-drawer-direction": "start",
        "data-kt-drawer-toggle": "#kt_aside_toggler"
      }, [
        (_ctx.displayAsidePrimary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_router_link, { to: "/" }, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("ul", _hoisted_7, [
                    _createElementVNode("li", _hoisted_8, [
                      _createElementVNode("a", _hoisted_9, [
                        _createElementVNode("span", _hoisted_10, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Layout/Layout-4-blocks.svg" })
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_11, [
                      _createElementVNode("a", _hoisted_12, [
                        _createElementVNode("span", _hoisted_13, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Group.svg" })
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_14, [
                      _createElementVNode("a", _hoisted_15, [
                        _createElementVNode("span", _hoisted_16, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Media/Equalizer.svg" })
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_17, [
                      _createElementVNode("a", _hoisted_18, [
                        _createElementVNode("span", _hoisted_19, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/General/Shield-check.svg" })
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_20, [
                      _createElementVNode("a", _hoisted_21, [
                        _createElementVNode("span", _hoisted_22, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Home/Library.svg" })
                        ])
                      ])
                    ]),
                    _createElementVNode("li", _hoisted_23, [
                      _createElementVNode("a", _hoisted_24, [
                        _createElementVNode("span", _hoisted_25, [
                          _createVNode(_component_inline_svg, { src: "media/icons/duotone/Files/File-plus.svg" })
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_26, [
                (_ctx.displayAsidePrimary && _ctx.displayAsideSecondary)
                  ? (_openBlock(), _createElementBlock("button", _hoisted_27, [
                      _createElementVNode("span", _hoisted_28, [
                        _createVNode(_component_inline_svg, { src: "media/icons/duotone/Navigation/Left-2.svg" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("button", _hoisted_30, [
                    _createElementVNode("span", _hoisted_31, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotone/Communication/Dial-numbers.svg" })
                    ])
                  ]),
                  _createVNode(_component_Dropdown3)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.displayAsideSecondary)
          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
              _createElementVNode("div", {
                id: "kt_aside_wordspace",
                class: _normalizeClass(["aside-workspace aside-workspace-width my-7 ps-5 pe-4 ps-lg-10 pe-lg-6", {
          'aside-workspace-width_full': _ctx.sidebarStateExpand
        }])
              }, [
                (!_ctx.displayAsidePrimary)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("i", {
                        class: "bi bi-list fz-22 cursor-pointer text-dark mb-4 toggle-button",
                        alt: "Кнопка меню",
                        title: "Переключение меню",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleSidebar()))
                      }),
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_router_link, {
                          to: "/",
                          class: "w-100"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.sidebarStateExpand)
                              ? (_openBlock(), _createElementBlock("img", {
                                  key: 0,
                                  class: "mh-50px",
                                  alt: "Agroru.com",
                                  src: _ctx.setHost('media/logos/logo-vector.svg')
                                }, null, 8, _hoisted_34))
                              : (_openBlock(), _createElementBlock("img", {
                                  key: 1,
                                  class: "w-100 mw-50px",
                                  alt: "Agroru.com",
                                  src: _ctx.setHost('media/logos/logo-mini-vector.svg')
                                }, null, 8, _hoisted_35))
                          ]),
                          _: 1
                        })
                      ]),
                      _createVNode(_component_KTAsideMenu, { menuConfig: _ctx.asideMenu }, null, 8, ["menuConfig"])
                    ], 64))
                  : (_openBlock(), _createElementBlock("div", _hoisted_36, [
                      _createElementVNode("div", _hoisted_37, [
                        _createVNode(_component_KTAsideMenu, { menuConfig: _ctx.asideMenu }, null, 8, ["menuConfig"])
                      ]),
                      _hoisted_38,
                      _hoisted_39
                    ]))
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ], 10, _hoisted_1))
    : _createCommentVNode("", true)
}